// import React, { useState } from "react";
// import ResourceForm from "./ResourceForm";
// import ResourceTable from "./ResourceTable";
// import EditResourceForm from "./EditResourceForm";

// const Resource = () => {
//   const [isFormVisible, setFormVisible] = useState(false);
//   const [editingResource, setEditingResource] = useState(null);

//   const handleEdit = (resource) => {
//     setEditingResource(resource);
//     setFormVisible(true);
//   };

//   const handleUpdate = () => {
//     setEditingResource(null);
//     setFormVisible(false);
//   };

//   const handleCancel = () => {
//     setEditingResource(null);
//     setFormVisible(false);
//   };

//   return isFormVisible ? (
//     editingResource ? (
//       <EditResourceForm 
//         resource={editingResource}
//         onCancel={handleCancel}
//         onUpdate={handleUpdate}
//       />
//     ) : (
//       <ResourceForm
//         onCancel={handleCancel}
//         onSave={() => setFormVisible(false)}
//       />
//     )
//   ) : (
//     <ResourceTable 
//       onAdd={() => setFormVisible(true)}
//       onEdit={handleEdit}
//     />
//   );
// };

// export default Resource;


import React, { useState, useEffect } from "react";
import ResourceForm from "./ResourceForm";
import ResourceTable from "./ResourceTable";
import EditResourceForm from "./EditResourceForm";

const Resource = () => {
  const [isFormVisible, setFormVisible] = useState(false);
  const [editingResource, setEditingResource] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    if (isFormVisible) {
      window.history.pushState({ formOpen: true }, '', window.location.pathname);

      const handlePopState = (event) => {
        if (isFormVisible) {
          event.preventDefault();
          setFormVisible(false);
          setEditingResource(null);
          window.history.pushState({ formOpen: true }, '', window.location.pathname);
        }
      };

      window.addEventListener('popstate', handlePopState);

      return () => {
        window.removeEventListener('popstate', handlePopState);
      };
    }
  }, [isFormVisible]);

  const handleEdit = (resource) => {
    setEditingResource(resource);
    setFormVisible(true);
  };

  const handleUpdate = () => {
    setEditingResource(null);
    setFormVisible(false);
    setRefreshTrigger(prev => prev + 1); // refresh table after edit
  };

  const handleSave = () => {
    setFormVisible(false);
    setRefreshTrigger(prev => prev + 1); // refresh table after add
  };

  const handleCancel = () => {
    setEditingResource(null);
    setFormVisible(false);
  };

  return isFormVisible ? (
    editingResource ? (
      <EditResourceForm
        resource={editingResource}
        onCancel={handleCancel}
        onUpdate={handleUpdate}
      />
    ) : (
      <ResourceForm
        onCancel={handleCancel}
        onSave={handleSave}
      />
    )
  ) : (
    <ResourceTable
      onAdd={() => setFormVisible(true)}
      onEdit={handleEdit}
      refreshTrigger={refreshTrigger}
    />
  );
};

export default Resource;